// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/PatentHeader/PatentHeader.css
// module id = 880
// module chunks = 0